





















































































































import TRTC, {RemoteStream} from 'trtc-js-sdk';
import {Component, Vue, Prop} from 'vue-property-decorator';
import {fetchSig, startMix} from './api';
import {initClient} from './util';
import InviteUser from './invite-user.vue';
import {api} from '@/plugins/api';
import {Mutations} from '@/store/mutations';
import {getVideoTimeBy5G, videoUrlAndTimeBy5GId} from '@/api/accident/edit.js';
import videoCall from '@/phoneVideo/video-call';

@Component({components: {InviteUser}})

export default class StreamVideo extends Vue {
  @Prop({
    type: Object,
    default: () => {
    }
  })
  public accident: any;
  inviteVisible = false;
  public inviteRole: any;

  get user() {
    return this.$store.state.user;
  }

  get videoType() {
    return this.$store.state.app.videoType;
  }

  getRoleByUserId(userId: string) {
    const reg = /(Agent|TrafficPolice|Insurance)/;
    return (
      {Agent: '坐席', TrafficPolice: '交警', Insurance: '保险员'}[
        userId.match(reg)?.[0] as string
        ] || '当事人'
    );
  }

  get userID() {
    return (
      {坐席: 'Agent', 交警: 'TrafficPolice', 保险员: 'Insurance'}[
        this.$store.getters.accidentRoleName
        ] + this.$store.state.user.sysUser.userId
    );
  }

  get roomID() {
    // return ((this.$route.params.id as string) ?? '').substring(3);
    return (this.$route.params.id.length > 15 ? (this.$route.params.id.substring(10)) : (this.$route.params.id.substring(3)))
  }

  get visitedViews() {
    return this.$store.getters.visitedViews;
  }

  get isHangupP() {
    return this.$store.state.app.isHangupP;
  }

  isInRoom() {
    return !!~this.visitedViews.findIndex(
      // ({name}) => name === 'AccidentAdd'
      ({name}) => name === 'mediatorInfo'
    );
  }

  accidentId() {
    return this.$route.params.id;
  }

  // public vClient: TRTC.Client | null = null;
public vClient:null = null;
  screenShot() {
    return new Promise((resolve, reject) => {
      if (!this.miniAppStream && !this.videoType) {
        this.$message.error('未获取到视频信息');
        reject(new Error('未获取到视频信息'));
      } else {
        let base64Url: any;
        if (this.videoType) {
          const cav = videoCall.videoTakePicture();
          if (cav) {
            base64Url = cav.toDataURL('image/png').replace(/^data:image\/\w+;base64,/, '');
          }
        } else {
          base64Url = this.miniAppStream && this.miniAppStream
            .getVideoFrame()
            ?.replace(/^data:image\/\w+;base64,/, '');
        }
        if (base64Url) {
          resolve(base64Url);
        } else {
          this.$message.error('截图失败');
          reject(new Error('未获取到视频帧'));
        }
      }
    });
  }

  // 启动本地流 同步
  public localStream = TRTC.createStream({
    userId: this.userID,
    audio: true,
    video: true
  });
  // 分享流
  public shareStream = TRTC.createStream({
    userId: this.userID,
    video: false,
    audio: true,
    screen: true
  });
  miniAppStream: RemoteStream | null = null;

  otherRemoteStreams: any = [];

  public async initRoom() {
    const data = await fetchSig(this.userID);
    console.info("data======", data)
    if (data !== null && data.code == 0) {
      console.log('this',this)
      //@ts-ignore
      this.vClient = initClient({
        appID: data.data.sdkAppId,
        user: this.userID,
        sig1: data.data.sign
      });
    } else {
      this.$message.warning('获取视频签名失败' + data.msg);
    }
  }

  public publishStream() {
    if (this.vClient) {
      //@ts-ignore
      this.vClient
        .publish(this.localStream)
        .then(() => {
          console.log('本地流发布成功');
        })
        .catch(error => {
          console.error('本地流发布失败 ' + error);
        });
    }
  }

  miniAppUserId = '';
  videoUrl = '';

  public subscribe(client: TRTC.Client) {
    // 加入房间
    client.on('stream-added', ({stream}) => {
      console.log('远端流增加: ' + stream.getId());
      // rtc.localStream_.audioPlayer_.stream_.mediaStream_
      // var context = new AudioContext();
      // var audioInput = context.createMediaStreamSource(stream);
      // var recorder =  context.createScriptProcessor.call(context, 0, 1, 1);
      // this.start = function () {
      //     audioInput.connect(recorder);
      //     recorder.connect(context.destination);
      // }
      // recorder.onaudioprocess = function (e) {
      //     bufferSendData(e.inputBuffer.getChannelData(0))
      // }
      //订阅远端流
      client.subscribe(stream);
    });
    client.on('stream-subscribed', ({stream}) => {
      console.log('远端流订阅成功：' + stream.getId());
      const userId = stream.getUserId();
      console.log('远端流UserId：' + userId);
      if (
        /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/.test(
          userId
        )
      ) {
        this.miniAppUserId = userId;
      }

      // 是否为小程序
      // if (userId === this.miniAppUserId) {
      if (1 == 1) {
        console.info("小程序视频........")
        this.miniAppStream = stream;
        startMix();

        this.$nextTick(() => {
          const streamId = stream.getId();
          if (document.getElementById(streamId)) {
            stream.play(streamId);
          }
        });
      } else {
        this.otherRemoteStreams.push(stream)

        console.log('非小程序视频---', this.otherRemoteStreams, this.otherRemoteStreams.length)

        // @ts-ignore
        // this.$refs.playerArea.innterHTML = ''

        // this.otherRemoteStreams.forEach((item: any) => {
        //
        //   if (item.isPlaying_) {
        //     return
        //   }
        //   document.getElementById(item.getId())?.parentElement?.remove();
        // let findDom = document.getElementById(item.getId())
        //
        // if (findDom) {
        //   item.play(item.getId())
        //   return
        // }

        let liDom = document.createElement('li')
        // @ts-ignore
        liDom.className = 'other-stream-wrapper'
        let divVideoDom = document.createElement('div')
        // @ts-ignore
        divVideoDom.className = 'other-stream'
        divVideoDom.style.height = (340 / (this.otherRemoteStreams.length + 1) - 20) + 'px'
        divVideoDom.id = stream.getId()

        liDom.append(divVideoDom)

        let divUserDom = document.createElement('div')
        // @ts-ignore
        divUserDom.className = 'role-name'
        divUserDom.innerText = this.getRoleByUserId(stream.getUserId())

        liDom.append(divUserDom)

        // @ts-ignore
        this.$refs.playerArea.append(liDom)

        stream.play(stream.getId())
        // })

        // // @ts-ignore
        // Array.from(this.$refs.playerArea.querySelectorAll('.other-stream')).forEach((item:any)=>{
        //   debugger
        //   if (!item.querySelector('video')){
        //     item?.parentElement?.remove();
        //   }
        // })


        // @ts-ignore
        // console.log(this.$refs.playerArea.appendChild)
        //
        //   <li
        //     v-for="stream in otherRemoteStreams"
        //     :key="stream.getId()"
        //   class="other-stream-wrapper"
        //     >
        //     <div
        // :id="stream.getId()"
        //   class="other-stream"
        // :style="{
        //   height: 340 / (otherRemoteStreams.length + 1) - 20 + 'px'
        // }"
        // />
        // <div class="role-name">
        //   {{ getRoleByUserId(stream.getUserId()) }}
        // </div>
        // </li>


      }

      // this.$nextTick(() => {
      //   const streamId = stream.getId();
      //   if (document.getElementById(streamId)) {
      //     stream.play(streamId);
      //   }
      // });
    });
    client.on('stream-removed', ({stream}) => {
      const removedId = stream.getId();
      console.log('远端流退出' + removedId);
      if (stream.getUserId() === this.miniAppUserId) {
        this.miniAppStream = null;
      } else {
        this.otherRemoteStreams.splice(
          this.otherRemoteStreams.findIndex(
            ({getId}) => getId() === removedId
          ),
          1
        );
        console.log('测试退出---', this.otherRemoteStreams, this.otherRemoteStreams.length)
        document.getElementById(removedId)?.parentElement?.remove();
      }
      this.$message.warning(
        `${this.getRoleByUserId(stream.getUserId())}已退出房间`
      );
    });
    // 被ban后回退
    client.on('client-banned', async error => {
      console.log('被踢出房间' + error);
      this.$message.error('您已被踢出房间');
      this.leave();
      this.$router.push({name: 'home'});
    });
  }

  async share() {
    console.log('进入分享');
    if (this.videoType) {
      videoCall.shareScreen(); // 5g投屏画面
      // videoCall.switchPoliceCamera(); // 切换回自己画面
    } else {
      //@ts-ignore
      this.vClient?.unpublish(this.localStream).then(() => {
        console.log('本地流退出成功');
        this.localStream.stop();
        // this.localStream.close();
        this.shareStream?.initialize().then(() => {
          console.log('分享初始化成功');
          this.shareStream.play('local-stream');
          //@ts-ignore
          this.vClient?.publish(this.shareStream).then(() => {
            console.log('分享流发布成功');
            // 屏幕分享流监听屏幕分享停止事件
            this.shareStream.on('screen-sharing-stopped', event => {
              console.log('屏幕分享停止');

              // 关闭屏幕分享流
                      //@ts-ignore
              this.vClient?.unpublish(this.shareStream).then(() => {
                console.log('分享流关闭成功');
                this.shareStream.stop();
                // this.shareStream.close();
                //  重新发布本地流
                this.localStream.initialize().then(() => {
                  this.localStream.play('local-stream');
                  this.publishStream();
                  console.log('本地流发布成功');
                })
              })
            });
          }).catch(() => {
            console.log('分享流发布失败');
          })
        })
      }).catch((e) => {
        switch (e.name) {
          case 'NotReadableError':
            console.log('确保系统允许当前浏览器获取屏幕内容');
            return;
          case 'NotAllowedError':
            if (e.message === 'Permission denied by system') {
              console.log('确保系统允许当前浏览器获取屏幕内容');
            } else {
              console.log('用户拒绝浏览器获取屏幕内容');
            }
            return;
          default:
            console.log('未知错误');
            return;
        }
      })
    }

    // try {
    //   await this.shareStream.initialize();
    //   this.shareStream.play('local-stream')
    //   console.log('分享初始化');
    //   try {
    //     try {
    //       await this.vClient?.unpublish(this.localStream);
    //       console.log('退出本地流成功');
    //     } catch (err) {
    //       console.log('退出本地流失败'+err);
    //     }
    //     this.localStream.stop();
    //     this.localStream.close();
    //     await this.vClient?.publish(this.shareStream);
    //     console.log('分享流推流成功');
    //   } catch (e) {
    //     console.log('分享流推流失败');
    //   }
    //   // 屏幕分享流监听屏幕分享停止事件
    //   this.shareStream.on('screen-sharing-stopped', async event => {
    //     // 关闭屏幕分享流
    //     await this.vClient?.unpublish(this.shareStream);
    //     this.shareStream.stop();
    //     this.shareStream.close();
    //     console.log('分享流关闭');
    //     //  重新发布本地流
    //     await this.localStream.initialize();
    //     this.localStream.play('local-stream');
    //     this.publishStream();
    //   });
    // } catch (e) {
    //   switch (e.name) {
    //     case 'NotReadableError':
    //       console.log('确保系统允许当前浏览器获取屏幕内容');
    //       return;
    //     case 'NotAllowedError':
    //       if (e.message === 'Permission denied by system') {
    //         console.log('确保系统允许当前浏览器获取屏幕内容');
    //       } else {
    //         console.log('用户拒绝浏览器获取屏幕内容');
    //       }
    //       return;
    //     default:
    //       console.log('未知错误');
    //       return;
    //   }
    // }
  }

  async leave() {
    if (this.videoType) {
      videoCall.hangupPhone(
        async () => {
          // 视频结束时间
          if (!this.isHangupP) {
            await getVideoTimeBy5G({accidentId: this.accidentId(), type: 1, time: new Date().getTime()}).then(() => {
              console.log('挂断了');
              this.$store.commit('app/SET_ISHANGUP', true);
            });
            // if (!(window as any).videoStream.length) {
            videoCall.stopRecord();
            // }
          }

        },
        () => console.log('挂断失败')
      );
      this.$store.commit('app/SET_VIDEODATA', {type: 0});
      this.$router.push({
        path: '/index'
      });
    }
    // 离开前关闭离开事件监听
    // @ts-ignore
    this.vClient?.off('stream-removed');
    try {
              //@ts-ignore
      await this.vClient?.unpublish(this.localStream);
              //@ts-ignore
      await this.vClient?.unpublish(this.shareStream);
    } catch (err) {
      console.log(err);
    }
    this.localStream.stop();
    this.localStream.close();
    this.shareStream.stop();
    this.shareStream.close();
    //@ts-ignore
    await this.vClient?.leave();
    await api.video.trtc.leave.r();
  }

  public inviteInfo(type) {
    (this.$refs[`userTree${type}`] as any).loadData();
  }

  public async created() {
    if (!this.videoType) {
      // 创建房间
      await this.initRoom();
      if (this.vClient) {
        // 订阅远程
        //@ts-ignore
        this.subscribe(this.vClient);
        // 加入房间
        //@ts-ignore
        this.vClient
          .join({roomId: Number(this.roomID)})
          .catch(error => {
            console.error('进房失败 ' + error);
          })
          .then(() => {
            console.log('进房成功');
            return this.localStream.initialize();
          })
          .then(() => {
            this.localStream.play('local-stream');
            //  发布
            this.publishStream();
          })
          .catch(error => {
            console.error('初始化本地流失败 ' + error);
          });
      }
    }
  }

  public isStreams() {
    if (this.otherRemoteStreams.length === 0) {
      return false;
    } else {
      return true;
    }
  }

  public videoStream: any[] = [];

  public async mounted() {
    if (this.videoType) {
      const id = this.accidentId();
      this.$nextTick(() => {
        const userInfo: any = localStorage.getItem('userInfo');
        videoCall.initVideoTag('POLICE_VIDEO_ID', 'USER_VIDEO_ID', userInfo, (data) => {
          console.log('接受消息', data);
          // let stream = data.match(/@(\S*)@/)[1];
          // if (!this.videoStream.length) {
          //   if (data.indexOf('开始') !== -1) {
          //     this.videoStream.push(stream)
          //   }
          // }else {
          //   if (data.indexOf('开始') !== -1) {
          //     if(!this.videoStream.includes(stream)) {
          //       this.videoStream.push(stream)
          //     }
          //   }else if(data.indexOf('离开') !== -1 && this.videoStream.includes(stream)) {
          //     let ind = this.videoStream.indexOf(stream)
          //     this.videoStream.splice(ind, 1)
          //   }
          // }
          // this.$store.commit('user/SET_VIDEOSTREAMARR',this.videoStream);
        })
        videoCall.answerPhone(
          (customVideoName: any, policeVideoName: any) => {
            console.log('接听成功');
            console.log('用户视频,' + customVideoName);
            console.log('客服视频,' + policeVideoName);
            // 计算5g视频
            getVideoTimeBy5G({accidentId: id, type: 0, time: new Date().getTime()});
            this.videoUrl = `https://get_video_file.aegis-info.com/getVideoFile?file=${customVideoName}`;
            // 视频地址保存
            videoUrlAndTimeBy5GId({accidentId: this.accidentId(), videoUrl: this.videoUrl});
            api.video.trtc.leave.r();
            var ring: any = document.getElementById('ringId');
            if (ring) {
              ring.pause();
            }
          },
          () => console.log('5g视频接听失败')
        );
      });
      api.video.trtc.leave.r().then((res: any) => {
        if (res && res.code === '200') {
          this.$store.commit(Mutations.CHANGE_LEAVE_STATE); // 修改离岗样式
        }
      });
    }
    this.inviteInfo(1);
    this.inviteInfo(2);

  }

  public async hideMyRoom() {
    this.leave();
    const id = this.$route.params.id;
    if (this.otherRemoteStreams.length === 0) {
      // console.log(666);
      // this.leave();
      sessionStorage.setItem('exitId', id);
      this.$router.push({name: 'home'});
      this.$stomp.disconnect(() => {
        console.log('断开连接');
      });
    } else {
      this.$router.push({
        path: '/index'
      });
    }
  }
}
